import axios from "axios";
import { getSession } from "../session";
import {
  handleRequest,
  handleResponse,
  handleResponseException
} from "./main.js";
import Cookies from 'js-cookie'
document.cookie = Cookies.get('SESSION')?`SESSION=${Cookies.get('SESSION')};Domain=${window.location.hostname};Path=/api/`:`SESSION='';Domain=${window.location.hostname};Path=/api/;Expires=0`;
// import { TENANT } from '@/common/constant.js'

// 创建一个AXIOS实例
const service = axios.create({
  baseURL: process.env.API,
  timeout: 180000, // 请求超时（单位：毫秒）,
  headers: {
    "Cache-Control": "no-store",
    "content-type": "application/json",
    Pragma: "no-cache"
  },
  withCredentials: true
});

// Request Interceptor
service.interceptors.request.use(
  config => {
    const cose =  sessionStorage.getItem('SESSION') || Cookies.get('SESSION')
    document.cookie = `SESSION=${cose};Domain=${window.location.hostname};Path=/api/`;
    config.headers['domain'] = window.location.hostname
    // Token
    if (getSession("token")) {
      config.headers.Authorization = getSession("token");
    }
    // 租户
    // config.headers.tenant = process.env.NODE_ENV == 'development' ? TENANT : 'tenant'
    // 产品
    if (
      getSession("productInfo") &&
      "productCode" in getSession("productInfo")
    ) {
      config.headers.product = getSession("productInfo").productCode;
    }
    // 组织角色
    if (getSession("orgRoleInfo") && "orgRoleId" in getSession("orgRoleInfo")) {
      config.headers.orgRoleId = getSession("orgRoleInfo").orgRoleId;
    }
    // 请求处理
    if (config.url != "order/submit") {
      handleRequest(config.headers);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response Interceptor
service.interceptors.response.use(
  response => {
    // 应答处理
    handleResponse(response.config.headers, response);
    
    // 特殊应答处理：投保单在申请时，但投保单已被后台撤回
    if(response && response.data && response.data.message == '人社需要重新进行项目审批，审批通过后再登录平台进行缴存申请') {
      setTimeout(_ => { window.open("/eguarantee?status=Layout", "_self") }, 3000)
      return response.data.message
    }

    // 返回处理
    if (response.data.success === false) {
      return Promise.reject(response.data);
    } else {
      return response;
    }
  },
  error => {
    // 应答异常处理
    if (error.response) {
      handleResponseException(error.response.config.headers, error.response);
    }
    // 响应超时处理
    else {
      const response = {
        status: "响应超时",
        statusText: "请求已经发送，但接收应答响应超时"
      };
      handleResponseException(error.config.headers, response);
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request/index.js